/**
 * Optional DATA (16-bit hex) descriptions per test — mirrors backend `TEST_ID_MAP_BY_ID`.
 * Add entries as: `113007: { dataDescTemplate: (dataValue) => "…" },`
 */

export const TEST_ID_DATA_DESCRIPTIONS = {
  /** Example pattern — extend with firmware-specific lookups */
  // 113013: { dataDescTemplate: (dataValue) => `Sensor raw ADC: ${dataValue}` },
};

/**
 * @param {number} testId
 * @param {number | null} dataValue
 */
export function resolveDataDescription(testId, dataValue) {
  if (!Number.isFinite(dataValue)) return null;
  const row = TEST_ID_DATA_DESCRIPTIONS[testId];
  if (typeof row?.dataDescTemplate === "function") {
    try {
      return row.dataDescTemplate(dataValue);
    } catch {
      return null;
    }
  }
  return null;
}
